export type DraggableType = "FORM" | "COLUMN" | "RULE" | "OPTION";

export type DraggableData = {
  type: DraggableType;
  id: string;
  index: number;
};

export const isDraggableDataOfType = (
  data: Record<string | symbol, unknown>,
  type: DraggableType,
): data is DraggableData => data.type === type && "id" in data && "index" in data;
